import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EventEmitterService } from '../../../services/event-emitter.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, fromEvent } from 'rxjs';
import { DeletePopupComponent } from '../../../modals/delete-popup/delete-popup.component';
import { ThirdpartyService } from '../../../services/thirdparty.service';
import { ThirdPartyPopupComponent } from '../../../modals/third-party-popup/third-party-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-third-party',
  templateUrl: './third-party.component.html',
  styleUrl: './third-party.component.scss',
})
export class ThirdPartyComponent implements OnInit, AfterViewInit {
  user;
  @ViewChild('searchInput') searchInput: ElementRef;
  search = '';
  thirdParties = [];
  page = 1;
  pageSize = 10;
  totalItems = 0;
  totalPages = 1;
  loading = false;
  destoryRef = inject(DestroyRef);

  constructor(
    private authenticationService: AuthenticationService,
    private thirdpartyService: ThirdpartyService,
    private modalService: BsModalService,
    public eventEmitterService: EventEmitterService,
    private translateService: TranslateService,
  ) {
    this.eventEmitterService.invokeEvent
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe((event) => {
        if (event == 'call-all-third-party') {
          this.resetPagination();
          this.getAllThirdParties();
        }
      });
  }

  ngOnInit() {
    this.getUser();
    this.resetPagination();
    this.getAllThirdParties();
  }

  ngAfterViewInit(): void {
    this.setupSearch();
  }

  async getUser() {
    this.user = await this.authenticationService.getUserFromToken();
  }

  resetPagination() {
    this.thirdParties = [];
    this.page = 1;
    this.pageSize = 10;
    this.totalItems = 0;
    this.totalPages = 1;
  }

  getAllThirdParties() {
    if (this.loading) {
      return;
    }
    this.loading = true;

    const apiData: any = {
      page: this.page,
      pageSize: this.pageSize,
    };

    if (this.search && this.search.trim().length > 0) {
      apiData.search = this.search;
    }
    this.thirdpartyService.getAllThirdParties(apiData).subscribe(
      (response: any) => {
        this.loading = false;

        this.thirdParties = response.items;
        this.page = response.page;
        this.pageSize = response.pageSize;
        this.totalItems = response.totalItems;
        this.totalPages = response.totalPages;

        this.thirdParties.forEach((item) => {
          item.email = item.rider.email;
        });

        console.log('this.thirdParties:');
        console.log(this.thirdParties);
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.loading = false;
      },
    );
  }

  setupSearch() {
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(debounceTime(3000))
      .subscribe((event: Event) => {
        this.resetPagination();
        this.getAllThirdParties();
      });
  }

  setSearch(event: any) {
    this.search = event.target.value;
  }

  onPageChange(event: { page: number; pageSize: number }) {
    this.page = event.page;
    this.pageSize = event.pageSize;
    this.getAllThirdParties();
  }

  addThirdParty() {
    this.modalService.show(ThirdPartyPopupComponent, {
      initialState: {
        title: 'new-third-party',
        type: 'new-third-party',
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  editThirdParty(thirdParty) {
    this.modalService.show(ThirdPartyPopupComponent, {
      initialState: {
        title: 'edit-third-party',
        type: 'edit-third-party',
        thirdParty: thirdParty,
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  deleteThirdPartyPopup(id) {
    this.modalService.show(DeletePopupComponent, {
      initialState: {
        title: 'delete-third-party',
        text: 'delete-third-party-text',
        id: id,
        onButtonClick: this.deleteThirdParty.bind(this),
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  async deleteThirdParty(id): Promise<void> {
    console.log('delete third party id:');
    console.log(id);
    return new Promise((resolve, reject) => {
      this.thirdpartyService.deleteThirdParty(id).subscribe(
        (response) => {
          console.log('response:');
          console.log(response);
          this.eventEmitterService.callAllThirdParties();
          resolve();
        },
        (error) => {
          console.log('error:');
          console.log(error);
          reject();
        },
      );
    });
  }
}
